import { SyntheticEvent } from 'react';

import { Box, Tab, Tabs } from '@mui/material';
import { EGlobalSearchFields } from '@patient-fi/fed-types';

interface TabsProps {
  value: EGlobalSearchFields | null;
  onChange: (value: EGlobalSearchFields | null) => void;
}
function TabsContainer({ value, onChange }: TabsProps) {
  const handleChange = (event: SyntheticEvent, newValue: EGlobalSearchFields) => {
    onChange(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={value} onChange={handleChange} textColor="primary" indicatorColor="primary">
        <Tab value={null} label="All" />
        <Tab value={EGlobalSearchFields.FULL_NAME} label="Borrower Name" />
        <Tab value={EGlobalSearchFields.SSN} label="SSN" />
      </Tabs>
    </Box>
  );
}

export default TabsContainer;
